﻿import React, { useState, useEffect } from 'react';
import GlobalDialog from '../Modal/GlobalDialog';
import NoteViewer from '../NoteViewer';
import { Qualification } from '../../models/Qualifications/qualification';
import { ModalMetadata } from '../../models/modal-metadata';
import { User } from '../../models/user';
import { ModalMessageType, NoteType } from '../../models/enums';
import { LookupItem } from '../../models/lookup-item';
import { ToastProps } from '../../models/toast-props';
import { CrudFunctions } from '../../utilities/crud-functions';
import { ItemBasicInformation } from '../../models/item-basic-information';
import ItemBasicInformationDialog from '../ItemBasicInformationDialog';
import DmaFooter from '../DmaFooter';
import TicketLogEntryForm from '../TicketLogEntryForm';

import DataGrid, {
    Column,
    FilterRow,
    Selection,
    Button as ColumnButton,
    HeaderFilter,
    Toolbar,
    Popup,
    Form,
    Lookup,
    Item as ToolbarItem,
    Editing,
    Paging,
    Pager,
    Scrolling,
    SearchPanel,
    LoadPanel
} from 'devextreme-react/data-grid';

import Diagram, {
    CustomShape,
    DefaultItemProperties,
    Nodes, AutoLayout, Group,
    Edges,
} from 'devextreme-react/diagram';

import List from 'devextreme-react/list';
import { Item } from 'devextreme-react/form';
import Button from 'devextreme-react/button';
import CheckBox from 'devextreme-react/check-box';
import Toast from 'devextreme-react/toast';
import { Popup as DialogPopup } from 'devextreme-react/popup';

import 'devexpress-diagram/dist/dx-diagram.min.css';

const listAttrs = { class: 'list' };
let key = 0;

export default function QualificationsManagement() {
    const [qualifications, setQualifications] =
        useState<Qualification[]>();

    const [users, setUsers] =
        useState<User[]>();

    const [selectedUser, setSelectedUser] =
        useState<User>();

    const [selectedDiagramUser, setSelectedDiagramUser] =
        useState<User>();

    const [selectedQualification, setSelectedQualification] =
        useState<Qualification>();

    const [selectedQualifiedUsersItemKeys, setSelectedQualifiedUsersItemKeys] =
        useState<string[]>();

    const [selectedQualifiedUser, setSelectedQualifiedUser] =
        useState<User>();

    const [qualificationCategories, setQualificationCategories] =
        useState<LookupItem[]>();

    const [itemBasicInformationDialogVisible, setItemBasicInformationDialogVisible] =
        useState<boolean>();

    const [itemBasicInformation, setItemBasicInformation] =
        useState<ItemBasicInformation>();

    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>();

    const [toastProps, setToastProps] =
        useState<ToastProps>();

    const [ticketLogEntryDialogVisible, setTicketLogEntryDialogVisible] =
        useState<boolean>();

    const [userDetailsPaneVisible, setUserDetailsPaneVisible] =
        useState<boolean>();    

    const [itemBasicInitInformation, setItemBasicInitInformation] =
        useState<ItemBasicInformation>();

    useEffect(() => {
        getAllData();
    }, []);


    key++;

    return (
        <div className="pw-content">
            <div className="lq-title-bar pw-form-header">
                <div className="lq-main-title">Qualifications Management</div>

                <div className="title-bar-spacer" />
                <div className="save-toolbar">
                    <Button id="goBackButton" text="" icon="arrowleft" type="normal"
                        hint="go back"
                        height={'2.6em'}
                        onClick={goBack} />
                </div>
            </div>

            <div className="pw-margin-top-05">
                <DataGrid
                    height="20rem"
                    dataSource={qualifications ? qualifications : []}
                    wordWrapEnabled={true}
                    allowColumnResizing={true}
                    columnResizingMode='widget'
                    keyExpr="qualificationId"
                    onSelectionChanged={onQualificationSelectionChanged}
                    onRowValidating={onQualificationRowValidating}
                    rowAlternationEnabled={true}
                    showRowLines={true}
                    showBorders={true}>

                    <LoadPanel enabled={true} />
                    <Paging defaultPageSize={30} />
                    <Pager
                        showPageSizeSelector={true}
                        allowedPageSizes={[30, 60, 100]}
                        showInfo={true} />
                    <Selection mode='single' />
                    <HeaderFilter visible={true} />
                    <FilterRow visible={true} />

                    <SearchPanel visible={true} />

                    <Column type="buttons" width="8rem">
                        <ColumnButton name="edit" />
                        <ColumnButton hint="audit information" icon="clock"
                            onClick={onQualificationAuditButtonClicked} />
                        <ColumnButton hint="information" icon="info"
                            onClick={onQualificationInformationButtonClicked} />
                        <ColumnButton name="delete" />
                    </Column>

                    <Column dataField='name' dataType='string' width='20%' />
                    <Column dataField='categoryId' caption="Category" dataType='number' width='15%'>
                        <Lookup dataSource={qualificationCategories ? qualificationCategories : []}
                            allowClearing={true}
                            displayExpr='name' valueExpr='id' />
                    </Column>
                    <Column dataField='description' dataType='string' width="65%" />


                    <Toolbar>
                        <ToolbarItem location='before'>
                            <div className="pw-datagrid-toolbar-template">
                                <div className="pw-datagrid-toobar-title">Qualifications</div>
                            </div>
                        </ToolbarItem>

                        <ToolbarItem location='after' name="searchPanel" />
                        <ToolbarItem location='after' name="addRowButton" />
                    </Toolbar>

                    <Editing mode="popup"
                        useIcons={true}
                        allowAdding={true}
                        allowUpdating={true}
                        allowDeleting={true}>

                        <Popup title="Edit Qualification" showTitle={true} width="55rem" height="25rem" />
                        <Form>
                            <Item dataField="name" />
                            <Item dataField="categoryId" />
                            <Item dataField="description" colSpan={2} />

                        </Form>
                    </Editing>

                </DataGrid>
            </div>

            <div>
                <div className="lq-sub-title pw-margin-left-05 pw-margin-top-1 pw-margin-bottom-05">Qualified Users</div>

                <div className="pw-comp-row">
                    <div className="pw-comp-20 pw-bg-rb-100 pw-default-border">
                        <List height="15rem"
                            selectionMode="single"
                            dataSource={selectedQualification && selectedQualification.qualifiedUsers ?
                                selectedQualification.qualifiedUsers : []}
                            selectedItemKeys={selectedQualifiedUsersItemKeys}
                            onSelectionChanged={onQualifiedUsersListSelectionChange}
                            itemRender={renderQualifiedUserListItem}
                            elementAttr={listAttrs}
                        />
                    </div>

                    <div className="pw-comp-20 pw-bg-rb-100 pw-default-border pw-margin-left-1">
                        <List height="15rem"
                            selectionMode="single"
                            dataSource={users ? users : []}
                            onSelectionChanged={onUsersListSelectionChange}
                            itemRender={renderUserListItem}

                        />
                    </div>
                </div>
            </div>

            <div>
                <div className="lq-sub-title pw-margin-left-05 pw-margin-top-1 pw-margin-bottom-05">Users Tree</div>

                <Diagram id="usersTreeDiagram" className="users-diagram"
                    showGrid={false} readOnly={true}
                    onSelectionChanged={onUsersDiagramSelectionChanged}
                    customShapeRender={renderUsersDiagramNode} simpleView={true}>
                    {users && users.map((user, index) => <CustomShape
                        type={`user${user.userId}`}
                        baseType="rectangle"
                        defaultHeight={1} defaultWidth={1.75}
                        allowEditText={false} allowResize={false}
                        key={index}
                    />)}
                    <Nodes dataSource={users}
                        keyExpr="userId" parentKeyExpr="reportsTo" typeExpr={itemTypeExpr}>
                        <AutoLayout type="tree" />
                    </Nodes>
                    <DefaultItemProperties connectorLineEnd="filledTriangle" />
                </Diagram>

                {/*
                <Diagram id="diagram" readOnly={true} showGrid={false}
                    height="90vh" simpleView={true}
                    onItemClick={onDiagramItemClick}
                    onOptionChanged={onDiagramOptionChanged}
                    onRequestEditOperation={onDiagramRequestEditOperation}
                    onRequestLayoutUpdate={onDiagramRequestLayoutUpdate}
                    onSelectionChanged={onDiagramSelectionChanged}
                    customShapeRender={customShapeTemplate}>
                    {workflowActions && workflowActions.map((t, idx) => <CustomShape
                        type={`task${t.id}`}

                        baseType="rectangle"
                        defaultWidth={1.5}
                        defaultHeight={1}
                        allowEditText={false}
                        allowResize={false}
                        key={idx} />)}

                    <PageSize width={20} />

                    <Nodes dataSource={workflowActions} keyExpr="id" parentKeyExpr="pid" typeExpr={itemTypeExpr} >
                        <AutoLayout type="tree" />
                    </Nodes>

                </Diagram>
                */}




            </div>

            <DmaFooter />

            {itemBasicInformationDialogVisible &&
                <DialogPopup visible={itemBasicInformationDialogVisible}
                    onHiding={hideItemBasicInformationDialog}
                    title="Item Basic Information"
                    width={'25rem'}
                    height={'21rem'}
                    dragEnabled={false}
                    resizeEnabled={false}>
                    <ItemBasicInformationDialog initInformation={itemBasicInitInformation}
                        onOkClick={hideItemBasicInformationDialog}
                        key={`IBI${key}`} />
                </DialogPopup>
            }

            {ticketLogEntryDialogVisible &&
                <DialogPopup visible={ticketLogEntryDialogVisible}
                    onHiding={hideTicketLogEntryDialog}
                    title="Ticket Log Entry"
                    width={'55rem'}
                    height={'45rem'}
                    dragEnabled={true}
                    resizeEnabled={true}>
                    <TicketLogEntryForm formName="Task Forms" contextData={selectedQualification}
                        onCancel={hideTicketLogEntryDialog}
                        onComplete={hideTicketLogEntryDialog}
                        key={`TLE${key}`} />
                </DialogPopup>
            }

            {userDetailsPaneVisible && 
                <DialogPopup visible={userDetailsPaneVisible}
                    onHiding={hideUserDetailsPane}
                    title="User Details"
                    width={'55rem'}
                    height={'45rem'}
                    dragEnabled={true}
                    resizeEnabled={true}>
                    <div>USER !
                    </div>
                </DialogPopup>
                    }

            {globalDialogVisible &&
                <GlobalDialog metadata={globalDialogMetadata} />
            }

        </div>
    );

    function onUsersDiagramSelectionChanged(e: any) {
        console.log("onUsersDiagramSelectionChanged");
        console.log(e);

        if (e.items && e.items.length > 0) {
            setSelectedDiagramUser(e.items[0].dataItem);
        }            
    }

    function onQualificationSelectionChanged(e: any) {
        if (e.selectedRowsData && e.selectedRowsData.length > 0)
            setSelectedQualification(e.selectedRowsData[0]);
    }

    function onQualifiedUsersListSelectionChange(e: any) {
        console.log("onQualifiedUsersListSelectionChange");
        console.log(e);

        if (e.addedItems && e.addedItems.length > 0)
            setSelectedQualifiedUser(e.addedItems[0]);

    }

    function onUsersListSelectionChange(e: any) {
        console.log("onUsersListSelectionChange");
        console.log(e);

        if (e.addedItems && e.addedItems.length > 0)
            setSelectedUser(e.addedItems[0]);

    }

    async function onQualificationRowValidating(e: any) {
        if (e.oldData) {
            let qualification = e.oldData as Qualification;

            if (qualification) {
                let updatedQualification = { ...qualification, ...e.newData };

                await updateQualification(updatedQualification)
                    .then(() => {
                        showToast("Qualification updated", "success");
                    })
                    .catch((res) => {
                        showMessage(res, ModalMessageType.Error, "Error Updating Qualification");
                    });
            }
        }
        else {
            if (e.newData) {
                let qualification = e.newData as Qualification;

                await insertQualification(qualification)
                    .then(() => {
                        showToast("Qualification saved", "success");
                    })
                    .catch((res) => {
                        showMessage(res, ModalMessageType.Error, "Error Inserting Qualification");
                    });
            }
        }
    }

    async function getQualifications() {
        await CrudFunctions.getData("qualifications/qualifications")
            .then((data) => {
                setQualifications(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Qualifications");
            });
    }

    async function getQualificationCategories() {
        await CrudFunctions.getData("common/taskcategories")
            .then((data) => {
                setQualificationCategories(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Qualification Categories");
            });
    }

    async function getAllUsers() {
        await CrudFunctions.getData("common/userstree")
            .then((data) => {

                console.log("users tree");
                console.log(data);

                setUsers(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Active Users");
            });
    }

    async function insertQualification(qualification: Qualification) {
        return await CrudFunctions.postData("qualifications/qualification", qualification);
    }

    async function updateQualification(qualification: Qualification) {
        return await CrudFunctions.putData("qualifications/qualification", qualification);
    }

    async function getAllData() {
        await Promise.all([
            getAllUsers(),
            getQualificationCategories(),
            getQualifications()
        ]);
    }

    //navigation
    function goBack() {
        history.back();
    }

    //render
    /*
    function renderRevalidationCell(cellData: any) {
        const currentDate = new Date();
            const revalidationDate = cellData.data.nextCalibrationDate;

            if (revalidationDate) {
            const daysDifference = PWDates.getDifferenceInDays(currentDate, new Date(revalidationDate))
 
            if (daysDifference >= 30)
            return (<div className="validation-pass">{PWDates.getLocalDateString(revalidationDate)}</div>);
            else if (daysDifference < 30 && daysDifference > 0)
            return (<div className="validation-warn">{PWDates.getLocalDateString(revalidationDate)}</div>);
            else
            return (<div className="validation-fail">{PWDates.getLocalDateString(revalidationDate)}</div>);
        }
            else {
            return (<div className="validation-fail">NA</div>);
        }
    }
            */

    function onQualificationAuditButtonClicked(e: any) {


    }

    //render

    function renderQualifiedUserListItem(data: any) {
        //console.log("renderQualifiedUserListItem");
        //console.log(data);

        if (data) {
            return (
                <div className="users-list-item pw-margin-right-05">
                    <i className="dx-icon-user users-list-item-text" />
                    <div className="users-list-item-text">{data.firstName} {data.lastName}</div>
                    <div className="users-list-item-icon"><Button icon="close" stylingMode="text"
                        onClick={onRemoveQualifiedUserClick} type="danger" ></Button> </div>
                </div>
            );
        }

        return <div></div>;
    }


    function itemTypeExpr(obj: { userId: string; }) {
        return `user${obj.userId}`;
    }

    function renderUsersDiagramNode(e: any) {
       // console.log("renderUsersDiagramNode");
        //console.log(e);

        if (e.dataItem) {
            return (
                <svg className="ud-card">
                    <text className="ud-user-fullname" x="50%" y="20%">{e.dataItem.fullName}</text>
                    <text className="ud-username" x="50%" y="45%">{e.dataItem.userName}</text>
                    <text className="ud-details-link" x="50%" y="85%" onClick={() => { setUserDetailsPaneVisible(true) }}>Show Details</text>
                </svg>
            );
        }
        else {
            return (
                <svg className="ud-card">
                    <text className="template-name" x="50%" y="20%"></text>
                </svg>
            );
        }
    }

    function showUserDetails() {
        console.log("showUserDetails");
        //console.log(e);

        showUserDetailsPane();
    }

    function renderUserListItem(data: any) {

        //console.log("renderUserListItem");
        //console.log(data);

        if (data) {
            return (
                <div className="users-list-item pw-margin-right-05">
                    <i className="dx-icon-user users-list-item-text" />
                    <div className="users-list-item-text">{data.firstName} {data.lastName}</div>
                    <div className="users-list-item-icon">
                        <Button icon="add" stylingMode="text"
                            onClick={onAddUserClick} type="success" ></Button> </div>
                </div>
            );
        }

        return <div></div>;
    }

    function onRemoveQualifiedUserClick(e: any) {
        console.log("onRemoveQualifiedUser");
        console.log(e);
    }

    function onAddUserClick(e: any) {
        console.log("onAddUser");
        console.log(e);


        //setSelectedUser(e);


    }

    //other
    function onQualificationInformationButtonClicked(e: any) {

        console.log("onQualificationInformationButtonClicked-----------------");
        console.log(e);

        if (e.row && e.row.data) {
            const qualification = e.row.data as Qualification;

            if (qualification) {
                setSelectedQualification(qualification);

                let itemInformation: ItemBasicInformation = {
                    rowPointer: qualification.qualificationId,
                    createTimestamp: qualification.createTimestamp,
                    lastModifiedTimestamp: qualification.modifyTimestamp,
                    createUser: qualification.createUser,
                    modifyUser: qualification.modifyUser
                };

                console.log("RESULT:");
                console.log(itemInformation);

                setItemBasicInformation(itemInformation);
                setItemBasicInformationDialogVisible(true);
            }
        }
    }

    function hideTicketLogEntryDialog() {
        setTicketLogEntryDialogVisible(false);
    }

    function hideItemBasicInformationDialog() {
        setItemBasicInformationDialogVisible(false);
    }

    function showUserDetailsPane() {
        setUserDetailsPaneVisible(true);
    }

    function hideUserDetailsPane() {
        setUserDetailsPaneVisible(false);
    }

    function showMessage(res: any, mode: ModalMessageType, title: string) {
        let mm: ModalMetadata = {
            error: res,
            mode: mode,
            title: title
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }

    function clearGlobalDialog() {
        setGlobalDialogMetadata(null);
        setGlobalDialogVisible(false);
    }

    function showToast(message: string, toastType: string) {
        let toastParams: ToastProps = {
            message: message,
            toastType: toastType,
            visible: true
        };

        setToastProps(toastParams);
    }

    function onToastHiding() {
        let toastParams: ToastProps = {
            message: undefined,
            toastType: undefined,
            visible: false
        };

        setToastProps(toastParams);
    }


}
